<template>
	<svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-sliders">
		<path d="M4.5 19.5V12.5M4.5 8.5V1.5M12.5 19.5V10.5M12.5 6.5V1.5M20.5 19.5V14.5M20.5 10.5V1.5M1.5 12.5H7.5M9.5 6.5H15.5M17.5 14.5H23.5" stroke="#101828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
.icon-sliders{

}
</style>